import { render, staticRenderFns } from "./AlarmButton.vue?vue&type=template&id=5c9c137c&"
import script from "./AlarmButton.vue?vue&type=script&lang=js&"
export * from "./AlarmButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports